/** * 左边菜单 */
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="" />
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from "../api/userMG";
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: []
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    let res = {
      success: true,
      data: [],
      msg: "success"
    };

    var permission = JSON.parse(localStorage.getItem("roles")).permission;
    console.log("permission====", permission);
    if (permission.indexOf("数据管理") != -1) {
      var menus = [];
      if (permission.indexOf("数据管理-数据统计") != -1) {
        menus.push({
          menuid: 941,
          icon: "icon-cat-skuQuery",
          menuname: "数据统计",
          hasThird: "N",
          url: "home/home",
          menus: null
        });
      }
      res.data.push({
        menuid: 1,
        icon: "li-icon-xiangmuguanli",
        menuname: "数据管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("用户管理") != -1) {
      var menus = [];

      if (permission.indexOf("用户管理-用户列表") != -1) {
        menus.push({
          menuid: 11,
          icon: "icon-cat-skuQuery",
          menuname: "用户列表",
          hasThird: "N",
          url: "user/User",
          menus: null
        });
      }

      res.data.push({
        menuid: 2,
        icon: "li-icon-xiangmuguanli",
        menuname: "用户管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    if (permission.indexOf("广告管理") != -1) {

      var menus = [];

      if (permission.indexOf("广告管理-开屏广告列表") != -1) {
        menus.push({
          menuid: 171,
          icon: "icon-cat-skuQuery",
          menuname: "广告列表",
          hasThird: "P",
          url: "advertisement/advertisement",
          menus: null
        });
      }
      res.data.push({
        menuid: 17,
        icon: "li-icon-xiangmuguanli",
        menuname: "广告管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    if (permission.indexOf("订单管理") != -1) {
      var menus = [];

      if (permission.indexOf("订单管理-商品订单列表") != -1) {
        menus.push({
          menuid: 21,
          icon: "icon-order-manage",
          menuname: "商品订单列表",
          hasThird: "N",
          url: "pay/Order",
          menus: null
        });
      }

      if (permission.indexOf("订单管理-充值记录列表") != -1) {
        menus.push({
          menuid: 233,
          icon: "icon-order-manage",
          menuname: "充值记录列表",
          hasThird: "N",
          url: "pay/payBalance",
          menus: null
        });
      }

      if (permission.indexOf("订单管理-余额明细列表") != -1) {
        menus.push({
          menuid: 234,
          icon: "icon-order-manage",
          menuname: "余额明细列表",
          hasThird: "N",
          url: "pay/walletBalanceDetails",
          menus: null
        });
      }

      if (permission.indexOf("订单管理-为学学院充值记录") != -1) {
        menus.push({
          menuid: 235,
          icon: "icon-cat-skuQuery",
          menuname: "为学学院充值记录",
          hasThird: "P",
          url: "registration_admin/rechargeRecord",
          menus: null
        });
      }

      res.data.push({
        menuid: 4,
        icon: "li-icon-xiangmuguanli",
        menuname: "订单管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("商品管理") != -1) {
      var menus = [];

      if (permission.indexOf("商品管理-商品列表") != -1) {
        menus.push({
          menuid: 31,
          icon: "icon-cat-skuQuery",
          menuname: "商品列表",
          hasThird: "N",
          url: "goods/Goods",
          menus: null
        });
      }

      res.data.push({
        menuid: 5,
        icon: "li-icon-xiangmuguanli",
        menuname: "商品列表",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("平台管理") != -1) {
      var menus = [];

      if (permission.indexOf("平台管理-系统用户") != -1) {
        menus.push({
          menuid: 63,
          icon: "icon-cat-skuQuery",
          menuname: "系统用户",
          hasThird: "N",
          url: "terrace/user",
          menus: null
        });
      }

      if (permission.indexOf("平台管理-实名认证") != -1) {
        menus.push({
          menuid: 64,
          icon: "icon-cat-skuQuery",
          menuname: "实名认证",
          hasThird: "N",
          url: "terrace/realName",
          menus: null
        });
      }

      if (permission.indexOf("平台管理-角色管理") != -1) {
        menus.push({
          menuid: 641,
          icon: "icon-cat-skuQuery",
          menuname: "角色管理",
          hasThird: "F",
          url: "terrace/Role",
          menus: null
        });
      }

      if (permission.indexOf("平台管理-评论管理") != -1) {
        menus.push({
          menuid: 65,
          icon: "icon-cat-skuQuery",
          menuname: "评论管理",
          hasThird: "W",
          url: "terrace/Review",
          menus: null
        });
      }

      if (permission.indexOf("平台管理-用户反馈") != -1) {
        menus.push({
          menuid: 66,
          icon: "icon-cat-skuQuery",
          menuname: "用户反馈",
          hasThird: "H",
          url: "terrace/Feedback",
          menus: null
        });
      }

      if (permission.indexOf("平台管理-提现列表") != -1) {
        menus.push({
          menuid: 67,
          icon: "icon-cat-skuQuery",
          menuname: "提现列表",
          hasThird: "H",
          url: "terrace/Withdraw",
          menus: null
        });
      }

      if (permission.indexOf("平台管理-基础设置") != -1) {
        menus.push({
          menuid: 68,
          icon: "icon-cat-skuQuery",
          menuname: "基础设置",
          hasThird: "H",
          url: "terrace/toExamine",
          menus: null
        });
      }
      res.data.push({
        menuid: 6,
        icon: "li-icon-xiangmuguanli",
        menuname: "平台管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("分类管理") != -1) {
      var menus = [];

      if (permission.indexOf("分类管理-分类列表") != -1) {
        menus.push({
          menuid: 71,
          icon: "icon-cat-skuQuery",
          menuname: "分类列表",
          hasThird: "O",
          url: "classification/Classification",
          menus: null
        });
        menus.push({
          menuid: 72,
          icon: "icon-cat-skuQuery",
          menuname: "附近商家",
          hasThird: "O",
          url: "nearbyMerchants/nearbyMerchants",
          menus: null
        });
      }

      res.data.push({
        menuid: 7,
        icon: "li-icon-xiangmuguanli",
        menuname: "分类列表",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("作品管理") != -1) {
      var menus = [];
      if (permission.indexOf("作品管理-作品列表") != -1) {
        menus.push({
          menuid: 81,
          icon: "icon-cat-skuQuery",
          menuname: "作品列表",
          hasThird: "P",
          url: "works/Works",
          menus: null
        });
      }
      res.data.push({
        menuid: 8,
        icon: "li-icon-xiangmuguanli",
        menuname: "作品管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("活动管理") != -1) {
      var menus = [];
      if (permission.indexOf("活动管理-活动列表") != -1) {
        menus.push({
          menuid: 91,
          icon: "icon-cat-skuQuery",
          menuname: "活动列表",
          hasThird: "P",
          url: "activity/Activity",
          menus: null
        });
      }
      res.data.push({
        menuid: 9,
        icon: "li-icon-xiangmuguanli",
        menuname: "活动管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    if (permission.indexOf("报名记录") != -1) {
      var menus = [];
      if (permission.indexOf("报名记录-家教报名记录") != -1) {
        menus.push({
          menuid: 321,
          icon: "icon-cat-skuQuery",
          menuname: "家教报名记录",
          hasThird: "P",
          url: "registration_admin/tutorRecordList",
          menus: null
        });
      }
      if (permission.indexOf("报名记录-家教报名记录") != -1) {
        menus.push({
          menuid: 322,
          icon: "icon-cat-skuQuery",
          menuname: "家长报名记录",
          hasThird: "P",
          url: "registration_admin/parentRecordList",
          menus: null
        });
      }
      res.data.push({
        menuid: 32,
        icon: "li-icon-xiangmuguanli",
        menuname: "报名记录",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    if (permission.indexOf("放映厅管理") != -1) {
      var menus = [];
      if (permission.indexOf("放映厅管理-放映厅列表") != -1) {
        menus.push({
          menuid: 101,
          icon: "icon-cat-skuQuery",
          menuname: "放映厅列表",
          hasThird: "P",
          url: "show/ScreenRoom",
          menus: null
        });
      }

      if (permission.indexOf("放映厅管理-放映厅购买列表") != -1) {
        menus.push({
          menuid: 102,
          icon: "icon-cat-skuQuery",
          menuname: "放映厅购买列表",
          hasThird: "P",
          url: "show/RoomBuy",
          menus: null
        });
      }

      res.data.push({
        menuid: 10,
        icon: "li-icon-xiangmuguanli",
        menuname: "放映厅管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("金字塔管理") != -1) {
      var menus = [];
      if (permission.indexOf("金字塔管理-金字塔列表") != -1) {
        menus.push({
          menuid: 111,
          icon: "icon-cat-skuQuery",
          menuname: "金字塔列表",
          hasThird: "P",
          url: "pyram/Pyram",
          menus: null
        });
      }

      res.data.push({
        menuid: 11,
        icon: "li-icon-xiangmuguanli",
        menuname: "金字塔管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("圈层管理") != -1) {
      var menus = [];
      if (permission.indexOf("圈层管理-圈层列表") != -1) {
        menus.push({
          menuid: 121,
          icon: "icon-cat-skuQuery",
          menuname: "圈层列表",
          hasThird: "P",
          url: "circles/Circles",
          menus: null
        });
      }

      if (permission.indexOf("圈层管理-圈层申请列表") != -1) {
        menus.push({
          menuid: 122,
          icon: "icon-cat-skuQuery",
          menuname: "圈层申请列表",
          hasThird: "P",
          url: "circles/Examine",
          menus: null
        });
      }

      res.data.push({
        menuid: 12,
        icon: "li-icon-xiangmuguanli",
        menuname: "圈层管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("课程管理") != -1) {
      var menus = [];
      if (permission.indexOf("课程管理-课程标签列表") != -1) {
        menus.push({
          menuid: 131,
          icon: "icon-cat-skuQuery",
          menuname: "课程标签列表",
          hasThird: "P",
          url: "task/TaskTag",
          menus: null
        });
      }

      if (permission.indexOf("课程管理-用户课程列表") != -1) {
        menus.push({
          menuid: 132,
          icon: "icon-cat-skuQuery",
          menuname: "用户课程列表",
          hasThird: "P",
          url: "task/Task",
          menus: null
        });
      }

      if (permission.indexOf("课程管理-平台课程列表") != -1) {
        menus.push({
          menuid: 133,
          icon: "icon-cat-skuQuery",
          menuname: "平台课程列表",
          hasThird: "P",
          url: "task/taskPlatformTask",
          menus: null
        });
      }

      res.data.push({
        menuid: 13,
        icon: "li-icon-xiangmuguanli",
        menuname: "课程管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("教培机构管理") != -1) {
      var menus = [];
      menus.push({
        menuid: 181,
        icon: "icon-cat-skuQuery",
        menuname: "教培机构列表",
        hasThird: "P",
        url: "institution/institution",
        menus: null
      });

      res.data.push({
        menuid: 18,
        icon: "li-icon-xiangmuguanli",
        menuname: "教培机构管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("商家服务") != -1) {
      var menus = [];
      menus.push({
        menuid: 191,
        icon: "icon-cat-skuQuery",
        menuname: "商家入驻列表",
        hasThird: "P",
        url: "merchant/merchant",
        menus: null
      });

      res.data.push({
        menuid: 19,
        icon: "li-icon-xiangmuguanli",
        menuname: "商家服务",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    if (permission.indexOf("自习室管理") != -1) {
      var menus = [];
      menus.push({
        menuid: 201,
        icon: "icon-cat-skuQuery",
        menuname: "自习室列表",
        hasThird: "P",
        url: "room_admin/room_list",
        menus: null
      });

      res.data.push({
        menuid: 20,
        icon: "li-icon-xiangmuguanli",
        menuname: "自习室管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    

    if (permission.indexOf("拉新配置管理") != -1) {
      var menus = [];
      if (permission.indexOf("拉新配置管理-拉新配置列表") != -1) {
        menus.push({
          menuid: 151,
          icon: "icon-cat-skuQuery",
          menuname: "拉新配置列表",
          hasThird: "P",
          url: "laxin/Laxin",
          menus: null
        });
      }
      res.data.push({
        menuid: 15,
        icon: "li-icon-xiangmuguanli",
        menuname: "拉新配置管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }

    if (permission.indexOf("卡密管理") != -1) {

      var menus = [];
      if (permission.indexOf("卡密管理-卡密批次列表") != -1) {
        menus.push({
          menuid: 161,
          icon: "icon-cat-skuQuery",
          menuname: "卡密批次列表",
          hasThird: "P",
          url: "cami/CamiBatch",
          menus: null
        });
      }
      if (permission.indexOf("卡密管理-卡密列表") != -1) {
        menus.push({
          menuid: 162,
          icon: "icon-cat-skuQuery",
          menuname: "卡密列表",
          hasThird: "P",
          url: "cami/Cami",
          menus: null
        });
      }
      res.data.push({
        menuid: 16,
        icon: "li-icon-xiangmuguanli",
        menuname: "卡密管理",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    if (permission.indexOf("字典配置") != -1) {
      var menus = [];
      
      menus.push({
          menuid: 221,
          icon: "icon-cat-skuQuery",
          menuname: "字典数据",
          hasThird: "O",
          url: "dictConfigure/dictConfigure",
          menus: null
        });
       
      res.data.push({
        menuid: 22,
        icon: "li-icon-xiangmuguanli",
        menuname: "字典配置",
        hasThird: null,
        url: null,
        menus: menus
      });
    }
    this.allmenu = res.data;

    console.log('左侧菜单',this.allmenu)
    // 获取图形验证码

    // 监听
    this.$root.Bus.$on("toggle", value => {
      this.collapsed = !value;
    });
  }
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue